// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3JWDQ","inputWrap":"Table_inputWrap__1Edgt","col":"Table_col__3XX_U","bmiTooltip":"Table_bmiTooltip__2ORN3"};